document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.tb-section').forEach(initTrustBar);
});

if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.tb-section');
    if (section) initTrustBar(section);
  });
}

function initTrustBar(section) {
  if (section.dataset.tbInitialized) return;
  section.dataset.tbInitialized = 'true';

  var list = section.querySelector('.tb-list');
  var dotsWrap = section.querySelector('[data-tb-dots]');
  var items = Array.prototype.slice.call(section.querySelectorAll('.tb-item'));

  if (!list || items.length < 2) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  // Build dots (only meaningful on mobile, hidden via CSS on desktop)
  items.forEach(function (item, index) {
    var dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'tb-dot';
    dot.setAttribute('aria-label', 'Ir para o item ' + (index + 1));
    if (index === 0) dot.classList.add('is-active');
    dot.addEventListener('click', function () {
      pause();
      currentIndex = index;
      scrollToCurrent();
      resumeSoon();
    });
    dotsWrap.appendChild(dot);
  });

  var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.tb-dot'));

  function setActiveDot(index) {
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
  }

  var currentIndex = 0;
  var intervalId = null;
  var resumeTimeout = null;
  var isRunning = false;

  function scrollToCurrent() {
var itemLeft = items[currentIndex].offsetLeft;
list.scrollTo({ left: itemLeft, behavior: 'smooth' });
    setActiveDot(currentIndex);
  }

  function advance() {
    currentIndex = (currentIndex + 1) % items.length;
    scrollToCurrent();
  }

  function start() {
    if (isRunning || prefersReducedMotion || !mobileQuery.matches) return;
    isRunning = true;
    intervalId = setInterval(advance, 3500);
  }

  function pause() {
    isRunning = false;
    clearInterval(intervalId);
  }

  function resumeSoon(delay) {
    clearTimeout(resumeTimeout);
    resumeTimeout = setTimeout(start, delay === undefined ? 3500 : delay);
  }

  // Keep dots in sync if the person swipes manually
  var scrollTimeout;
  list.addEventListener('scroll', function () {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function () {
      var listLeft = list.getBoundingClientRect().left;
      var closestIndex = 0;
      var closestDistance = Infinity;

      items.forEach(function (item, index) {
        var distance = Math.abs(item.getBoundingClientRect().left - listLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      currentIndex = closestIndex;
      setActiveDot(currentIndex);
    }, 80);
  });

  list.addEventListener('touchstart', function () {
    pause();
  }, { passive: true });

  list.addEventListener('touchend', function () {
    resumeSoon();
  }, { passive: true });

  mobileQuery.addEventListener('change', function (e) {
    if (e.matches) {
      start();
    } else {
      pause();
    }
  });

  start();
}